import contact from "@/api/contact";
import httpService from "@/common/http.service";
export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        getPersonalisation() {
          contact.getListCustomFields(
            { select: 1, perPageCount: 200 },
            (data) => {
              this.$store.dispatch("ddb/setPersonalizationMenu", data);
            }
          );
        },
        uploadImage(file, fn) {
          let fd = new FormData();
          fd.append("image", file);
          httpService
            .post(
              "api/image/upload",
              fd,
              "",
              process.env.VUE_APP_CONTENT_HOSTING_URL
            )
            .then(function (res) {
              fn(res.images[0]);
            })
            .catch(function (res) {
              fn("", res.message);
            });
        },
        toastMessage(message, variant = "success", delay = 2000) {
          let img = require("@/assets/img/icons/success-tick.svg");
          if (variant === "danger") {
            img = require("@/assets/img/icons/warning-round-ico.svg");
          }
          const h = this.$createElement;
          const error = h("div", { class: ["d-flex", "font-15"] }, [
            h("span", {}, [h("img", { attrs: { src: img, width: 24 } })]),
            h("span", message),
          ]);
          this.$bvToast.toast(error, {
            autoHideDelay: delay,
            appendToast: false,
            variant: variant,
            toaster: "b-toaster-bottom-left",
            noCloseButton: false,
            toastClass: "mc-toast-n",
          });
        },
      },
    });
  },
};
